import React from 'react';
import { Link } from "react-router-dom";
import UserModal from '../modal/UserModal';
import { db } from '../firebase';
import { MyContext } from '../context';
import { Content } from '../components';
export default class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: null, users: {},
      key: '',
      page: { start: 0, end: 10, interval: 10 }
    }
  }
  updateUser(status, key) {
    db.updateUser(key, status);
  }
  subMenu() {
    return (
      <React.Fragment>
        <li className="m-nav__item">
          <a className="btn m-nav__link">
            <span className="m-nav__link-text">Users</span>
          </a>
        </li>
      </React.Fragment>
    )
  }
  leftMenu() {
    return <MyContext.Consumer>
      {state => {
        return (
          <li className="m-menu__item">
            <a className="btn m-menu__link">
              <span className="m-menu__link-text">All Users</span>
              <span className="m-menu__link-badge">
                <span className="m-badge m-badge--success">{state.totalUser}</span>
              </span>
            </a>
          </li>
        )
      }}
    </MyContext.Consumer>
  }
  render() {
    return <Content title="Users" state={this} />
  }
  content() {
    return (
      <MyContext.Consumer>
        {state => {
          let { page } = this.state;
          let sn = page.start + 1;
          return (
            <React.Fragment>
              <table id="example" className="table table-striped table-bordered" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>S.N.</th>
                    <th>User's Name</th>
                    <th>Email</th>
                    <th>Signup Date</th>
                    <th>Mobile</th>
                    {/* <th>Status</th> */}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    state.users
                      .filter(item => {
                        return this.props.search.trim() == "" || item.fullName.toLowerCase().includes(this.props.search.toLowerCase().trim())
                      }).slice(this.state.page.start, this.state.page.end)
                      .map((item) => {
                        return this.userComp(item, sn++);
                      })
                  }
                </tbody>
              </table>
              <UserModal show={this.state.detailModal} id="driverDetailModel" title="User Details" footer={
                <div className="modal-footer">
                  <button type="button" className="btn btn-primary">Edit User</button>
                </div>
              }
                user={this.state.user}
                hide={() => {
                  this.setState({
                    detailModal: false,
                    user: null
                  })
                }} />
              <UserModal show={this.state.deleteModal} id="driverDeleteModel" title="Delete User Details" footer={
                <div className="modal-footer">
                  <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={e => { this.delete(this.state.user.key) }}>Delete User</button>
                  <button type="button" className="btn btn-primary" onClick={e => { this.delete(false) }}>Cancel</button>
                </div>
              }
                user={this.state.user}
                hide={() => {
                  this.setState({
                    deleteModal: false,
                    user: null
                  })
                }} />
            </React.Fragment>
          )
        }}</MyContext.Consumer>
    )
  }
  delete(key) {
    if (key)
      db.deleteUser(key);
    this.setState({
      deleteModal: false,
      user: null
    })
  }
  userComp(user, sn) {
    var strDate = "";
    if (user.joinDate) {
      let date = new Date(user.joinDate);
      let month = date.getMonth() + 1
      strDate = (date.getDate() >= 10 ? date.getDate() : "0" + date.getDate()) + "/" + (month < 10 ? "0" + month : month) + "/" + date.getFullYear();
    }
    let fun = (e) => {
      this.setState({
        detailModal: true,
        user
      })
    };
    return (
      <tr key={user.key}>
        <td onClick={fun}><a className="btn">{sn}</a></td>
        <td onClick={fun}><a className="btn">{user.fullName}</a></td>
        <td onClick={fun}><a className="btn">{user.email}</a></td>
        <td onClick={fun}><a className="btn">{strDate}</a></td>
        <td onClick={fun}><a className="btn">{user.phoneNumber}</a></td>
        {/* <td>
      {users[user.key].status ? <i className="fa fa-check-circle text-success"></i> : <i className="fa fa-close-circle text-success"></i>}
    </td> */}
        <td>
          <div className="btn-group align-users-center">
            <a className="text-muted btn" onClick={fun}>
              <i className="la la-pencil-square-o"></i>
            </a>
            <a className="text-danger btn" onClick={(e) => {
              this.setState({
                deleteModal: true,
                user
              })
            }}>
              <i className="la la-trash-o"></i>
            </a>
          </div>
        </td>
      </tr>
    )
  }
}


// WEBPACK FOOTER //
// ./src/include/Users.js